///<reference path="../common/data-template-base.ts"/>

module Meevo.Components.Controls.SmartMover {

  import Dictionary = _.Dictionary;

  export class ReportProdCatsManufacturers extends DataTemplateBase implements IDataTemplate {
    public title: string;
    public allSelectedLabel: string;
    public totalSelectedMessage: string;

    manufacturers: ReportManufacturersCollection;
    productCategories: ReportProductCategoryCollection;

    get leafCollection() {
      return this.manufacturers;
    }

    get collection() {
      return this.productCategories;
    }

    constructor(model: Dictionary<any>, properties: string[], { criteria, dataService }) {
      super(model, properties, criteria);

      this.manufacturers = new ReportManufacturersCollection(this.model[properties[1]], [], { criteria });
      this.productCategories = new ReportProductCategoryCollection(this.model[properties[0]], [], { criteria });

      this.manufacturers.setParentCollection(
        this.productCategories,
        new ProdCatManufacturersStrategy(this.productCategories, this.manufacturers, dataService, { criteria })
      );

      this.title = 'LABEL_MANUFACTURERS';
      this.allSelectedLabel = 'LABEL_ALL_MANUFACTURERS';
      this.totalSelectedMessage = 'LABEL_TOTAL_MANUFACTURERS_SELECTED';
    }
  }
}
